<template>
    <SettingsCard id="block-time" title="Учёт времени" class="ds-settings-block">
        <SettingsBlockState
            :status="editor.load.global"
            :rows="3"
            error-text="Не удалось загрузить параметры учёта времени."
            @retry="editor.loadGlobal()"
        >
            <div class="ds-settings-param-table" role="table" aria-label="Учёт времени">
                <div class="ds-settings-param-row ds-settings-param-head" role="row">
                    <span role="columnheader">Параметр</span>
                    <span role="columnheader">Значение</span>
                    <span role="columnheader">Как работает</span>
                </div>
                <div
                    v-for="field in TIME_FIELDS"
                    :id="`setting-${field.key}`"
                    :key="field.key"
                    class="ds-settings-param-row"
                    :class="rowClass(field.key)"
                    role="row"
                >
                    <span class="ds-settings-param-name" role="cell">{{ field.label }}</span>
                    <span role="cell">
                        <SettingsNumberField
                            :model-value="valueOf(field.key)"
                            :label="field.label"
                            :unit="field.unit"
                            :changed="editor.changedAnchors.value.has(`setting-${field.key}`)"
                            :invalid="isInvalid(field.key)"
                            error-text="Введите целое число не меньше 0"
                            :disabled="editor.saving.value"
                            @update:model-value="editor.setGlobal(field.key, $event)"
                        />
                    </span>
                    <span class="ds-settings-param-hint" role="cell">{{ hintOf(field.key) }}</span>
                </div>
            </div>
        </SettingsBlockState>
    </SettingsCard>
</template>

<script setup lang="ts">
import SettingsCard from '@/ui/SettingsCard.vue'
import SettingsBlockState from './SettingsBlockState.vue'
import SettingsNumberField from './SettingsNumberField.vue'
import { useSettingsEditor } from './useSettingsEditor'
import { TIME_FIELDS, formatSecondsAsMinutes, parseNonNegativeInt, type GlobalNumberKey } from './settingsModel'

const editor = useSettingsEditor()

const valueOf = (key: GlobalNumberKey) => {
    const value = editor.globalValue(key)
    return typeof value === 'string' ? value : null
}

const isInvalid = (key: GlobalNumberKey) => parseNonNegativeInt(valueOf(key)) === null

const rowClass = (key: GlobalNumberKey) => ({
    'is-changed': editor.changedAnchors.value.has(`setting-${key}`),
    'is-highlighted': editor.highlightedAnchor.value === `setting-${key}`,
})

// Пояснения — по макету D; окно отметки пересчитывается из введённых секунд в минуты.
function hintOf(key: GlobalNumberKey) {
    if (key === 'VIOLATION_TOLERANCE_MINUTES') return 'Отметка позже начала смены в пределах допуска — не нарушение'
    if (key === 'VIOLATION_TOLERANCE_MINUTES_EXIT') return 'Уход раньше окончания смены в пределах допуска — не нарушение'
    const seconds = parseNonNegativeInt(valueOf(key))
    return seconds === null ? 'Можно отметиться заранее до начала смены' : `Можно отметиться за ${formatSecondsAsMinutes(seconds)} до начала смены`
}
</script>
